function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97.061,
    height: 108.046,
    viewBox: "0 0 25.681 28.587",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fontVariationSettings: "normal",
      vectorEffect: "none",
      fill: "#ff9481",
      fillOpacity: 0.74902,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      InkscapeStroke: "none",
      stopColor: "#000"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M491 304.148v120.905a21.887 21.887 0 0 1-10.937 18.949l-75.355 43.506c-19.87 11.471-44.695-2.871-44.708-25.813v-6.356c0-67.263-55.925-97.829-87.12-109.647-9.855-3.739-20.405 3.485-20.405 14.021v.04c.534 41.623 22.781 80.136 58.89 101.341l43.48 25.532a10.154 10.154 0 0 1 5.008 8.373c0 .107 0 .2.013.307.307 7.959-8.306 13.127-15.21 9.147L239.95 444.001A21.9 21.9 0 0 1 229 425.052V338.04c.013-22.942 24.838-37.27 44.708-25.813l5.622 3.245c58.209 33.531 112.585.414 138.411-20.685 3.739-3.058 5.555-7.371 5.555-11.671 0-5.115-2.564-10.176-7.531-13.033-36.322-20.351-80.79-20.338-117.219.334l-43.854 24.891c-3.005 1.709-6.677 1.749-9.748.147-.093-.053-.174-.093-.267-.147-7.051-3.712-7.224-13.754-.32-17.747l104.707-60.452a21.871 21.871 0 0 1 21.887 0l75.355 43.506c19.857 11.471 19.857 40.141 0 51.625l-5.515 3.178c-.107.067-.214.12-.32.187-57.928 33.678-56.419 97.215-51.078 130.092 1.242 7.652 7.839 12.673 14.876 12.673 2.51 0 5.088-.641 7.505-2.043 35.788-21.273 58.009-59.798 58.316-101.675l.374-50.424c.027-3.459 1.829-6.664 4.754-8.52.08-.053.174-.107.254-.16 6.741-4.246 15.528.628 15.528 8.6z",
    style: {
      fontVariationSettings: "normal",
      vectorEffect: "none",
      fill: "#ff9481",
      fillOpacity: 0.74902,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      InkscapeStroke: "none",
      stopColor: "#000",
      stopOpacity: 1
    },
    transform: "translate(-22.446 -20.993) scale(.09802)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2d44dc40d9be3a38ad9bd8ebedaaf7d3.svg";
export { ForwardRef as ReactComponent };